import { render } from "./StoreTransferShippingView.vue?vue&type=template&id=017071d2&scoped=true"
import script from "./StoreTransferShippingView.vue?vue&type=script&lang=js"
export * from "./StoreTransferShippingView.vue?vue&type=script&lang=js"

import "./StoreTransferShippingView.vue?vue&type=style&index=0&id=017071d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017071d2"]])

export default __exports__